import { Button, ButtonGroup, Content, Dialog, Divider, Heading } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import React from 'react';

const PluginAcquiredDialog = (props) => {
  const { userData, close, onAccept } = props;
  return (
    <Dialog>
      <Heading>Application acquired</Heading>
      <Divider />
      <Content>
        <p>The application has been acquired.</p>
        <p>
          Your system administrator must approve your acquisition before you can install and use your application. We
          will contact you at {userData?.email} once your system administrator reviews your acquisition.
        </p>
      </Content>
      <ButtonGroup>
        <Button variant="secondary" onPress={close}>
          Close
        </Button>
        <Button variant="cta" onPress={onAccept}>
          Manage your app
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default PluginAcquiredDialog;

PluginAcquiredDialog.propTypes = {
  close: PropTypes.func,
  onAccept: PropTypes.func,
};
